import {
    Button, Box, TextField, Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import AddCommentIcon from '@mui/icons-material/AddComment';

const StyledCommentBox = styled(Box)(({ theme }) => ({
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    background: 'rgba(0, 0, 0, 0.03)',
    marginTop: theme.spacing(1),
    position: 'relative',
}));

interface PropTypes {
    entity: Models.IngestConfigApi.RelevanceTests.ScoredEntity;
    onCommentChange: (
        entity: Models.IngestConfigApi.RelevanceTests.ScoredEntity,
        comment: string
    ) => void;
}

export const CommentBox = (props: PropTypes): JSX.Element | null => {
    const {
        entity,
        onCommentChange,
    } = props;

    const [isEditingComment, setIsEditingComment] = useState(false);
    const hasComment = entity?.reason && entity.reason.length > 0;

    const handleCommentChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        onCommentChange(entity, event.target.value);
    };

    return (
        <Box sx={{ mt: 1 }}>
            {!hasComment && !isEditingComment && (
                <Button
                    size="small"
                    startIcon={<AddCommentIcon />}
                    variant="text"
                    onClick={(): void => setIsEditingComment(true)}
                >
                    Comment
                </Button>
            )}

            {hasComment && !isEditingComment && (
                <StyledCommentBox>
                    <Typography sx={{ pr: 4 }} variant="body2">
                        <strong>Comment:</strong>
                        {' '}
                        {entity.reason}
                    </Typography>
                    <Button
                        size="small"
                        startIcon={<EditIcon />}
                        sx={{
                            position: 'absolute',
                            top: '4px',
                            right: '4px',
                            minWidth: 'auto',
                            p: '4px',
                        }}
                        variant="text"
                        onClick={(): void => setIsEditingComment(true)}
                    >
                        Edit
                    </Button>
                </StyledCommentBox>
            )}

            {isEditingComment && (
                <Box>
                    <TextField
                        fullWidth
                        multiline
                        placeholder="Add your comment here"
                        rows={2}
                        size="small"
                        value={entity.reason}
                        onBlur={(): void => {
                            setIsEditingComment(false);
                        }}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>): void => {
                            handleCommentChange(event);
                        }}
                    />
                </Box>
            )}
        </Box>
    );
};
